import { apiClient, getHeaders } from '@/services/axiosConfig'

export default {
  getReviewSuggestions (auth, payload) {
    return apiClient({
      method: 'post',
      url: 'v1/general/reviews/suggestions',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  getOrderForReview (auth, payload) {
    return apiClient({
      method: 'get',
      url: `v1/general/orders/${payload.id}/for-review`,
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  createReviewsFromOrder (auth, payload) {
    return apiClient({
      method: 'post',
      url: `v1/general/orders/${payload.id}/reviews`,
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  }
}
